module.exports = __webpack_public_path__ + "static/media/ben-mullins-5QTQz-oYk1A_small.6923e3a9.jpg";